import { PaginatedDataStore } from '../../../ng-services/paginated-data.store';

type KeyObject<T> = { [key in keyof Required<T>]: boolean };
type KeyArray<T> = (keyof Required<T>)[];

export abstract class AbstractTableFiltersComponent<FilterInterface> {
    static $inject = ['$location'];

    protected filters!: FilterInterface;
    protected initialFilter!: FilterInterface;

    constructor(protected $location: ng.ILocationService) {}

    abstract getFilterKeyObject(): KeyObject<FilterInterface>;

    get allPossibleFilters(): KeyArray<FilterInterface> {
        const keyObject = this.getFilterKeyObject();
        return Object.keys(keyObject) as KeyArray<FilterInterface>;
    }

    abstract get store(): PaginatedDataStore<any, FilterInterface>;

    onFiltersChanged(newFilters: FilterInterface) {
        // set empty filters to undefined to they will get removed from url
        const filters = this.allPossibleFilters.reduce(
            (filters, filter) => ({ ...filters, [filter]: newFilters[filter] || undefined }),
            {}
        );

        // update url query string
        Object.entries(filters).forEach(([key, value]) => this.$location.search(key, value as any));

        this.filters = newFilters;

        // load filtered results
        this.store.setFilters({
            ...newFilters,
            ...this.initialFilter, // force initial filters to always be used
        });
    }

    /**
     * resolve filters from url
     */
    updateFiltersFromUrl() {
        const query = this.$location.search();

        // create filters object to be used as initial values for filters component
        this.filters = this.allPossibleFilters.reduce(
            (filters, filter) => ({
                ...filters,
                [filter]: query[filter],
            }),
            {} as FilterInterface
        );

        this.onFiltersChanged(this.filters);
    }
}
